__turbopack_context__.v({
  "button": "index-module__mBn4Ca__button",
  "loading": "index-module__mBn4Ca__loading",
});
